<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header" v-if="product._id">
        Editing App "{{ product.slotGeneral.name }}"
        <span class="badge" :class="product.status.class" title="Status of app">{{ product.status.label }}</span>
      </div>
      <div class="card-body">
        <form v-if="product">
          <div class="alert alert-danger" role="alert" v-show="message">
            {{ message }}
          </div>
          <wizard ref="wizard" :steps="steps" :onSave="saveWizard" :modeWizard="modeWizard">      
            <!-- Datails page -->      
            <div slot="page-details">        
              <div class="row">
                <div class="col-12">
                  <!-- Application name -->
                  <div class="form-group">
                    <label for="name-input">App name</label>
                    <input disabled="disabled" class="form-control" type="text" v-model="product.slotGeneral.name" id="name-input">
                  </div>
                  <!-- Application price -->
                  <div class="form-group">
                    <label for="viewer-check-input" class="mr-4">App price</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="appPrice" v-model="product.slotGeneral.price" value="0"> Free App
                      </label>
                    </div>
                  </div>
                  <!-- Certifications -->
                  <div class="form-group">
                    <label for="certifications-check-input" class="mr-4">Certifications</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.certifications" value="ce"> CE
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.certifications" value="fda"> FDA
                      </label>
                    </div>
                  </div>
                  <!-- Viewer -->
                  <div class="form-group">
                    <label for="viewer-check-input" class="mr-4">Viewer</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.viewer" name="viewer" value="osirix"> Osirix
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.viewer" name="viewer" value="horos"> Horos
                      </label>
                    </div>
                    <!-- <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" name="viewer" v-model="product.slotGeneral.viewer" value="standalone"> Standalone
                      </label>
                    </div> -->
                  </div>
                  <!-- Overview -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mt-2">
                        <label for="overview-textarea">Overview</label>
                        <p>{{ product.slotDetails.overview }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Applications/Clinical area/Modality -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <label for="description-textarea">
                            <h4>Categories</h4>
                          </label>
                        </div>           
                        <div class="col-md-4">
                          <label>Applications</label>
                          <div class="form-check" v-bind:key="application" v-for="application in applications">
                            <label class="form-check-label">
                              <input disabled="disabled" class="form-check-input" type="checkbox" :value="application" v-model="product.slotDetails.categories"> {{ application }}
                            </label>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label>Clinical area</label>
                          <div class="form-check" v-bind:key="ca" v-for="ca in clinicalAreas">
                            <label class="form-check-label">
                              <input disabled="disabled" class="form-check-input" type="checkbox" :value="ca" v-model="product.slotDetails.categories"> {{ ca }}
                            </label>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label>Modality</label>
                          <div class="form-check" v-bind:key="mod" v-for="mod in modalities">
                            <label class="form-check-label">
                              <input disabled="disabled" class="form-check-input" type="checkbox" :value="mod" v-model="product.slotDetails.categories"> {{ mod }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Description -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="description-textarea">
                          <h4>Product description</h4>
                        </label>
                        <p v-html="product.slotDetails.description"></p>
                      </div>
                    </div>
                  </div>
                  <!-- KEY FEATURES -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="features-textarea">
                          <h4>Key features</h4>
                        </label>
                        <p id="features" v-html="product.slotDetails.features"></p>
                       </div>
                    </div>
                  </div>
                  <!-- SYSTEM REQUIREMENT -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="systemrequirement-textarea">
                          <h4>System requirement</h4>
                        </label>
                        <p v-html="product.slotDetails.systemRequirement"></p>
                       </div>
                    </div>
                  </div>
                  <!-- LAST UPDATES -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="lastupdates-textarea">
                          <h4>Last updates</h4>
                        </label>
                        <p v-html="product.slotDetails.lastUpdates"></p>
                       </div>
                    </div>
                  </div>        
                  <!-- ADD VIDEO -->
                  <!-- <div class="row">
                    <div class="col-md-12">            
                      <div class="form-group">
                        <label for="video-url-input">Youtube video</label>
                        <input disabled="disabled" class="form-control" type="url" v-model="product.slotDetails.video.src">
                       </div>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="publications-textarea">
                          <h4>Publications</h4>
                          <p v-if="product.slotPublications.publications && !product.slotPublications.publications">No publications</p>
                          <ul>
                            <li :key="pub.link" v-for="pub in product.slotPublications.publications">
                              <a :href="pub.link" target="_new"><strong>{{ pub.title }}</strong></a>
                            </li>
                          </ul>
                        </label>
                      </div>
                    </div>
                  </div>
                <!-- ADD VIDEO -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="video-textarea">   
                        <h4>Youtube video</h4>
                        <p>
                          <iframe v-for="(video, videoIndex) in product.slotDetails.videos" :key="videoIndex" width="300" height="200" :src="video.src" class="mr-2"></iframe>
                        </p>
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- ADD USERGUIDE -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="logo-file-input">Userguide</label>
                        <!--"product.slotDetails.userguide"></upload-file-input-->
                       </div>
                    </div>
                  </div>
                  <!-- Is App already distributed? -->
                  <div class="form-group">
                    <label for="link-external-distributed-input" class="mr-4">Is your app already distributed online?</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="externaldistributed" :checked="product.slotGeneral.externalLinkDist"> Yes
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="externaldistributed" :checked="!product.slotGeneral.externalLinkDist" > No
                      </label>
                    </div>
                    <div class="form-input">
                      <input disabled="disabled" class="form-control" id="is-already-distributed-input" placeholder="" type="url" v-model="product.slotGeneral.externalLinkDist">
                    </div>
                   </div>            
                </div>
              </div>
            </div>
            <!-- Digital content page -->
            <div slot="page-digit-content">
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-warning" v-if="!product.slotGeneral.app.name">No file uploaded for this app</div>
                  <table class="table" v-if="product.slotGeneral.app.name">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th>Title</th>
                        <th>Size</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">{{ product.slotGeneral.app.name }}</th>
                        <td>{{ product.slotGeneral.app.name }}</td>
                        <td>{{ displaySize }}</td>
                        <td><a :href="`https://api.womia.io/media/${product.slotGeneral.app.slug}`" class="link-download">Download</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Images page -->
            <div slot="page-images">
              <div class="row">
                <div class="col-12">
                  <!-- Logo -->
                  <div class="form-group">
                    <label for="logo-file-input">App logo</label>
                    <div class="d-flex flex-row flex-wrap">
                      <img class="d-block logo-app" :src="product.slotImages.logo.slug | media"></img>
                    </div>
                  </div>
                  <!-- Screenshots -->
                  <div class="form-group">
                    <label for="screenshots-file-input">Screenshots</label>
                    <div class="d-flex flex-row flex-wrap">
                      <div class="screenshots mr-2" v-for="(image, imageIndex) in product.slotImages.screenshots" :key="image.slug">
                        <img class="d-block" :src="image.slug | media" :style="{ width: '100px', height: '70px' }"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Notification page -->
            <div slot="page-notifications" id="page-notifications">
              <div class="row">
                <div class="col-md-10 py-3">
                  <div class="form-group row">
                    <label for="approvalSelect" class="col-sm-3 col-form-label">Approval</label>
                    <div class="col-sm-9">
                      <select class="form-control" id="approvalSelect" v-model="product.newStatus">
                        <option value="approved">Approved</option>
                        <option value="pending">Waiting for approval</option>
                        <option value="declined">Declined</option>
                        <option value="closed">Closed</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-3">Kindly check if you need to send mail to user about this product update</div>
                    <div class="col-sm-9">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="inputRecipient" class="col-sm-3 col-form-label">Recipient</label>
                    <div class="col-sm-9">
                      <input type="email" class="form-control" id="inputRecipient" placeholder="Email">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="notifToUser" class="col-sm-3 col-form-label">Subject</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" id="notifToUser" placeholder="Notification to user">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="notifToUser" class="col-sm-3 col-form-label">Message</label>
                    <div class="col-sm-9">
                      <vue-editor id="message" :editorToolbar="customToolbar"></vue-editor>
                    </div>
                  </div>            
                </div>
              </div> 
            </div>
          </wizard>
        </form>
      </div>
    </div>    
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Wizard from '@/components/Wizard'
import Dialog from '@/components/Dialog'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'EditProductAdmin',
  components: { 'vue-editor': VueEditor, 'wizard': Wizard, 'modal': Dialog },
  computed: {
    displaySize() {
      const sizeBin = this.product.slotGeneral.technicalDetails.size
      const divid = (sizeBin > 1000 * 1000) ? { nb: 1000 * 1000, unit: ' MB' } : { nb: 1000, unit: ' KB' }
      return Math.round(this.product.slotGeneral.technicalDetails.size / divid.nb * Math.pow(10, 1)) / Math.pow(10, 1) + divid.unit
    }
  },
  data() {
    return {
      message: null,
      showModal: false,
      modeWizard: 'tab',
      steps: [{
        label: 'Details',
        slot: 'page-details'
      },
      {
        label: 'Digital content',
        slot: 'page-digit-content'
      },
      {
        label: 'Images',
        slot: 'page-images'
      },
      {
        label: 'Notifications',
        slot: 'page-notifications'
      }],
      publication: {},
      product: {
        slotGeneral: {
          technicalDetails: {}
        },
        slotImages: {
          logo: {}
        },
        slotDetails: {
          video: {}
        },
        slotPublications: {}
      },
      applications: [
        'workflow',
        'visualisation',
        'quantification',
        'reporting'
      ],
      modalities: ['mri', 'ultrasound', 'xray', 'ct', 'pet'],
      clinicalAreas: ['cardiology', 'vascular', 'neurology', 'oncology', 'dental'],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ['clean']
      ]
    }
  },
  mixins: [validationMixin],
  validations: {
    product: {
      slotGeneral: {},
      slotImages: {},
      slotDetails: {}
    }
  },
  created: function() {
    if (this.$route.params.slug) {
      this.fetchData()
    }
  },
  methods: {
    hideMessages() {
      this.message = null
    },
    showErrorMessage(message) {
      this.message = message
    },
    fetchData() {
      this.$http.get(`product/admin/${this.$route.params.slug}`).then(
        response => {
          this.populateProduct(response.data)
        },
        err => {
          // error callback
          console.log(err)
        }
      )
    },
    populateProduct(product) {
      /* set general params */
      this.product._id = product._id
      this.product.slugRef = product.slugRef
      const viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger' },
        'approved': { 'label': 'Approved', 'class': 'badge-success' },
        'closed': { 'label': 'Closed', 'class': 'badge-secondary' }
      }
      this.product.status = viewStatus[product.status]
      this.product.newStatus = product.status
      this.product.slotGeneral = {
        name: product.name,
        app: product.app,
        technicalDetails: product.technicalDetails || {},
        certifications: product.certifications,
        viewer: product.viewer,
        externalLinkDist: product.externalLinkDist,
        price: product.price
      }
      /* set images params */
      this.product.slotImages = {
        logo: product.logo,
        screenshots: product.screenshots
      }
      /* set details params */
      this.product.slotDetails = {
        overview: product.overview,
        categories: product.categories,
        description: product.description,
        features: product.features,
        systemRequirement: product.systemRequirement,
        lastUpdates: product.lastUpdates,
        videos: product.videos || [],
        userGuide: product.userGuide
      }
      /* set publications params */
      this.product.slotPublications = {
        publications: product.publications || []
      }
    },
    action(promise) {
      this.hideMessages()

      if (!this.$v.$invalid) {
        promise.then(
          response => {
            const redirectToAppsList = {
              path: '/admin/product'
            }
            this.$router.push(redirectToAppsList)
          },
          err => {
            // error callback
            this.showErrorMessage('Sorry but an error occurred when submitting form')
            console.log(err)
          }
        )
      } else {
        this.showErrorMessage('Please make sure all required fields are filled out correctly')
      }
    },
    updateNewStatus() {
      // TODO use popup for confirmation
      this.action(
        this.$http.post(`product/admin/${this.$route.params.slug}`, { '_id': this.product._id, 'status': this.product.newStatus, 'slugRef': this.product.slugRef })
      )
    },
    saveWizard(currentPage) {
      this.updateNewStatus()
      return true
    }
  }
}
</script>
<style>
  .app-file .box {
    display: inline-block;
    padding: 4px;
    min-width: 100px;
  }
</style>
<style scoped>
  .form-check-input {
    top: -3px;
  }
  #page-notifications .form-check-input {
    margin: 0;
  }
  .form-group > label {
    font-size: 14px;
  }
  .logo-app {
    width: 200px;
    height: 100%;
    border: 1px solid #d8d4d4;
    box-shadow: 1px 2px #c3b3b3;
  }
</style>




// WEBPACK FOOTER //
// src/admin/views/product/EditApp.vue